

import { Company } from "../models/Company";
import { Po } from "../models/Po";
import { ExtendCompnayData, VendorRequestChangeData } from "../models/VendorRequestChange/VendorRequestChangeData";
import { AxiosConfig } from "./AxiosConfig";
import qs from "qs";

    const getCompany = async (
      vendorId:number,
      successCallback: (companyData: Array<Company>) => void,
      errorCallback: (error: Error) => void
    ) => {
      try {
        const resp = await AxiosConfig.get("/Vendor/GetCompany");
        successCallback(resp.data);
      } catch (err: any) {
        // Handle Error Here
        console.error(err);
        errorCallback(err);
      }
    };

  const getPO = async (
    vendorId:number,
    companyCode: string,
    successCallback: (poData: Array<Po>) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      //const resp = await AxiosConfig.get("/VendorExtend/GetBlockedVendorPoCodes?vendorId=" + vendorId + "&coCode="+companyCode);
      const resp = await AxiosConfig.get("/Vendor/GetPO", {
        params: { companyCode: companyCode },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

const submitVendorExtendRequest = async (
  vendorExtendSubmitData: any,
    successCallback: (vendorExtendData: any) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.post("/VendorExtend/ExtendVendor", vendorExtendSubmitData);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

const getSavedExtendData = async (
    requestId: number,
    successCallback: (extendList: ExtendCompnayData[]) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/VendorExtend/GetExtendVendors?requestId=" + requestId);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };  

export const VendorExtendService = {
    //getExtendMetaData,
    getCompany,
    getPO,
    submitVendorExtendRequest,
    getSavedExtendData
  };